export const mockApis = {
  title: 'Athena APIs Documentation',
  filterAll: (count: number) => `All (${count})`,
  filterVerified: (count: number) => `Verified (${count})`,
  filterUnverified: (count: number) => `Unverified (${count})`,
  catalogueErrorMessage: 'Could not load the Athena API catalogue.',
  emptyAll: 'No endpoints available.',
  emptyVerified: 'No endpoint has been verified against Athena yet.',
  emptyUnverified: 'Every endpoint has been verified.',
  selectEndpointPrompt: 'Select an endpoint to see its parameters.',
  serviceTagNote: 'Logged as',
  noServiceTagNote: 'Writes no request log — this call bypasses the integration logger.',
  parametersHeading: 'Parameters',
  requiredLabel: (names: string) => `Required: ${names}`,
  responseHeading: 'Response',
  runButton: 'Run',
  clearButton: 'Clear',
  noResponseMessage: 'Run the endpoint to see a response.',
  fileParamLabel: (paramName: string) => `${paramName} (file)`,
  uploadFileLabel: (paramName: string) => `Upload a file for ${paramName}`,
  apiErrorMessage: (apiName: string) => `${apiName} failed — see the response panel`,
  imageProcessErrorMessage: (paramName: string) => `Failed to process image for ${paramName}`,
  requestFailedMessage: 'Request failed'
} as const;
